import { Pipe, PipeTransform } from '@angular/core';
import { OrderByService } from './order-by.service';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  constructor(private service: OrderByService) {}

  transform(array: any[], field: string, desc: boolean): any[] {
    return this.service.instant(array, field, desc);
  }
}
